import { For, type JSX } from 'solid-js'
import introCakeStarSvg from '~/assets/figma/intro-cake-star.svg'
import introCakeboxOpenSvg from '~/assets/figma/intro-cakebox-open.svg'
import introProgressArcSvg from '~/assets/figma/intro-progress-arc.svg'
import introProgressBaseSvg from '~/assets/figma/intro-progress-base.svg'
import introShopSvg from '~/assets/figma/intro-shop.svg'
import introStampImg from '~/assets/figma/intro-stamp.png'
import { m } from '~/paraglide/messages'

type IntroListItem = {
  num: number
  icon: () => JSX.Element
  text: () => string
}

const LIST_ITEMS: IntroListItem[] = [
  {
    num: 1,
    icon: () => (
      <span class="relative block size-9">
        <img
          src={introProgressBaseSvg}
          alt=""
          aria-hidden="true"
          class="absolute inset-0 size-full"
        />
        <img
          src={introProgressArcSvg}
          alt=""
          aria-hidden="true"
          class="absolute inset-0 size-full"
        />
        <span class="absolute inset-0 grid place-items-center text-[13px] font-bold leading-none text-bakery-brown-soft">
          60
        </span>
      </span>
    ),
    text: () => m.Bakery_intro_list_1(),
  },
  {
    num: 2,
    icon: () => (
      <span class="relative block size-10">
        <img
          src={introCakeboxOpenSvg}
          alt=""
          aria-hidden="true"
          class="absolute left-[-1.7px] top-[1.7px] h-[37px] w-[44px] max-w-none"
        />
        <img
          src={introCakeStarSvg}
          alt=""
          aria-hidden="true"
          class="absolute left-[5px] top-[-1px] size-[10px]"
        />
      </span>
    ),
    text: () => m.Bakery_intro_list_2(),
  },
  {
    num: 3,
    icon: () => (
      <img src={introStampImg} alt="" aria-hidden="true" class="size-10" />
    ),
    text: () => m.Bakery_intro_list_3(),
  },
  {
    num: 4,
    icon: () => (
      <span class="grid size-9 place-items-center rounded-[27px] bg-bakery-shop">
        <img src={introShopSvg} alt="" aria-hidden="true" class="size-[22px]" />
      </span>
    ),
    text: () => m.Bakery_intro_list_4(),
  },
]

export function IntroList(props: { staggerStartMs?: number } = {}) {
  return (
    <ul class="flex w-full flex-col items-start gap-4">
      <For each={LIST_ITEMS}>
        {(item, i) => {
          const start = props.staggerStartMs
          const animate = start !== undefined
          return (
            <li
              class="flex w-full items-center gap-4"
              classList={{ 'animate-intro-rise opacity-0': animate }}
              style={
                animate
                  ? { 'animation-delay': `${start + i() * 200}ms` }
                  : undefined
              }
            >
              <div class="flex shrink-0 items-center gap-3">
                <span class="grid size-6 place-items-center rounded-full bg-[#ebcabd] text-[16px] font-bold leading-5 text-bakery-brown-mid">
                  {item.num}
                </span>
                <div class="grid size-10 place-items-center">{item.icon()}</div>
              </div>
              <p class="flex-1 whitespace-pre-wrap text-[14px] leading-5 text-bakery-brown">
                {item.text()}
              </p>
            </li>
          )
        }}
      </For>
    </ul>
  )
}

export const INTRO_LIST_ITEM_COUNT = LIST_ITEMS.length
